import RestClient from './RestClient';
import { Routine } from '../models';

class Routines extends RestClient {
    constructor() {
        super({
            model: Routine,
            entryPoint: 'routines',
            id_field: '_id',
            resource: 'routine',
            resources: 'routines',
        });
    }

    run(id: string) {
        return this.POST(`/${this.entryPoint}/${id}/run`, {})
            .then((response) => response.json());
    }

    listRuns(params?: AnyObj) {
        return this.GET(`/${this.entryPoint}/runs`, params || {})
            .then((response) => response.json());
    }

    seed(projectId: string) {
        return this.POST(`/${this.entryPoint}/seed`, { project: projectId })
            .then(async (response) => {
                const json = await response.json();
                if (!response.ok)
                    throw new Error(json?.err || json?.error || 'Seed failed');
                return json;
            });
    }
}

const RoutinesApi = new Routines();
export default RoutinesApi;
